const Paginator = require("_fil/fil-global-frontend/paginator");

class AMCPaginator extends Paginator {
    constructor(rootElement, opts = {}) {
        super(rootElement, opts);
    }

    setScrollRestoration(option = "manual") {
        if ("scrollRestoration" in history) {
            history.scrollRestoration = option;
        }
    }

    bindPageShow() {
        if ($("[data-paginator-results]").length) {
            window.addEventListener("pageshow", (event) => {
                this.updatePerPageOn("back_forward", this.perPage);
            });
        }
    }

    updatePerPageOn(perfEntriesType, perPageNum) {
        const perfEntries = performance.getEntriesByType("navigation");
        if (perfEntries[0].type === perfEntriesType) {
            this.$perPageInput.val(perPageNum);
        }
    }
}

module.exports = AMCPaginator;
